import React from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function Profile() {
  const { currentUser, firebaseUser } = useAuth();

  if (!firebaseUser || !currentUser) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-extrabold tracking-tight text-gray-900 mb-8 text-center">Profile</h1>
          <div className="bg-white shadow-lg rounded-2xl p-8 text-center text-gray-500 border border-gray-200">
            Loading user information or not logged in.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="max-w-3xl mx-auto w-full">
        <h1 className="text-4xl font-extrabold tracking-tight text-gray-900 mb-8 text-center">
          My Profile
        </h1>
        <div className="bg-white shadow-lg rounded-2xl overflow-hidden border border-gray-200">
          <div className="px-8 py-10">
            <div className="space-y-8">
              <div>
                <h3 className="text-2xl font-bold text-[#00bfae] mb-4">Personal Information</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-500">Name</label>
                    <div className="mt-1 text-lg text-gray-900 font-semibold">{currentUser.name}</div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-500">Email</label>
                    <div className="mt-1 text-lg text-gray-900 font-semibold">{currentUser.email}</div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-500">Role</label>
                    <div className="mt-1 text-lg text-gray-900 font-semibold">
                      {currentUser.role.charAt(0).toUpperCase() + currentUser.role.slice(1)}
                    </div>
                  </div>
                </div>
              </div>

              {currentUser.role === 'rider' && (
                <div>
                  <h3 className="text-2xl font-bold text-[#00bfae] mb-4">Rider Information</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-500">Phone Number</label>
                      <div className="mt-1 text-lg text-gray-900 font-semibold">{currentUser.phoneNumber}</div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-500">Status</label>
                      <div className="mt-1">
                        <span
                          className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                            currentUser.isAvailable
                              ? 'bg-green-100 text-green-800'
                              : 'bg-red-100 text-red-800'
                          }`}
                        >
                          {currentUser.isAvailable ? 'Available' : 'Unavailable'}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 